import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PageLoader from "../components/PageLoader";
import { convertAndPerformCalculation } from "../libs/blackscholes";
import { Constants } from "../libs/Constants";
import { get } from "../libs/dbFunctions";
import { formatCurrency, formatDate } from "../libs/utils";

const BlackScholeWidget = ({ period, tranche, activeCompany }) => {
  const [loading, setLoading] = useState(false);
  const [blackSchole, setBlackSchole] = useState({
    outputs: {
      ecofv: 0,
      epofv: 0,
      value_discount: 0,
      value_85_call: 0,
      value_15_put: 0,
      total_value_per_share: 0,
    },
  });
  useEffect(() => {
    loadBlackSchole();
  }, [period, activeCompany]);

  // This function is used to load black schole data for current period
  async function loadBlackSchole() {
    setLoading(true);
    try {
      let id = {
        companyId: activeCompany.id,
        startDate: period.periodStartdate,
      };

      let values = {};
      const periodsSelected = await get(Constants.dbTypes.PERIOD, id);

      if (
        "blackSchole" in periodsSelected &&
        periodsSelected.blackSchole.length > 0
      ) {
        let blackSchole = Object.assign(periodsSelected.blackSchole[0]);
        let row = {};
        row.stock_price = blackSchole.stockPrice;
        row.exercise_price = blackSchole.stockPrice;
        row.volatility = blackSchole.volatility;
        for (let key in blackSchole) {
          // this is done because we want to show for tranche 1 always
          if (key.startsWith("tranche1")) {
            row.term = blackSchole[key].term;
            row.discount_rate = blackSchole[key].discountRateBEY;
            row.arqd = blackSchole[key].annualRateQuarterlyDiv;
          }
        }
        //For every transche calculate the Grant Date Fair Value
        values = convertAndPerformCalculation(row);
        setBlackSchole(values);
      }
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  }

  return (
    <React.Fragment>
      {period && (
        <h2>
          {" "}
          Black Scholes -{" "}
          {formatDate(period.periodStartdate, Constants.DATEFORMAT.MONYYYY)}
        </h2>
      )}
      {!period && <h2>Black Scholes - No Period </h2>}
      <PageLoader isActive={loading} individual={true}>
        <div className="exp-view-box">
          <span>
            <div className="td-left">Estimated Call Option Fair Value:</div>
            <div className="td-right">
              {formatCurrency(blackSchole.outputs.ecofv)}
            </div>
          </span>
          <span>
            <div className="td-left">Estimated Put Option Fair Value:</div>
            <div className="td-right">
              {formatCurrency(blackSchole.outputs.epofv)}
            </div>
          </span>
          <span>
            <div className="td-left">Value Discount:</div>
            <div className="td-right">
              {formatCurrency(blackSchole.outputs.value_discount)}
            </div>
          </span>
          <span>
            <div className="td-left">Value of 85% Call Option:</div>
            <div className="td-right">
              {formatCurrency(blackSchole.outputs.value_85_call)}
            </div>
          </span>
          <span>
            <div className="td-left">Value of 15% Put Option:</div>
            <div className="td-right">
              {formatCurrency(blackSchole.outputs.value_15_put)}
            </div>
          </span>
          <hr />
          <span>
            <div className="td-left">
              <b>Total Value per Share:</b>
            </div>
            <div className="td-right">
              <b>{formatCurrency(blackSchole.outputs.total_value_per_share)}</b>
            </div>
          </span>
          <h3>
            <a className="cursor-pointer secondary" href="/blackScholes">
              View Full Black Scholes
            </a>
          </h3>
        </div>
      </PageLoader>
    </React.Fragment>
  );
};

export default BlackScholeWidget;
